import React, { FunctionComponent } from 'react';
import { useInjection } from '@murphy-frontend/common/contexts/InversifyContext';
import AuthServiceType, { IAuthService } from '@murphy-frontend/common/interfaces/IAuthService';
import MyMurphyLogo from "@murphy-frontend/web-core/assets/img/mymurphy_logo.svg"

interface ErrorFallbackProps {
  error: Error,
  resetErrorBoundary: () => void
}

const ErrorFallback: FunctionComponent<ErrorFallbackProps> = ({ error, resetErrorBoundary }) => {
  const authService = useInjection<IAuthService>(AuthServiceType.IAuthService);

  const clickLogout = () => {
    authService.logoutHard();
  };

  return (
    <div className="error-page" role="alert">
      <div>
        <MyMurphyLogo className="logo" alt="logo" />
        <h1>Oops!<br />An error has occurred.</h1>
        <div className="error-quote">
          <p className="quote">"Anything that can go wrong, will go wrong."</p>
          <p className="author">- Murphy's Law</p>
        </div>
        <div className="error-description">
          <p>In this case, the following went wrong:</p>
          <pre>{error.message}</pre>
        </div>
        <button onClick={resetErrorBoundary}>
          Go to Home
        </button>
      </div>
      <button className="logout-button" onClick={clickLogout}>
        Log out
      </button>
    </div>
  );
}

export default ErrorFallback;